module.exports = __webpack_public_path__ + "img/first_wave_bottom.58b3c698.svg";